import { Box, Button, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { generateCertificateNumber } from "../utils/certificateUtils";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";
import ExperienceCertificate from "../reciept/ExperienceCertificate";
import { downloadCertificatePDF } from "../utils/experiencePDF";
import authService from "../Auth/AuthService";
import { useLocation, useNavigate } from "react-router-dom";

const ExperienceCertificatePage = ({user}) => {
  const [type, setType] = useState("experience");
  const location = useLocation().state;
  const emp = location?.emp;
  const hasFetched = useRef(false);
  const [school, setSchool] = useState({});
  const [show, setShow] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
    loadSchool();
    // sessionStorage.setItem("hide", true);
  }, []);

  const loadSchool = async () => {
    try {
      if (user?.mas_id !== undefined && user?.mas_id !== 'undefined') {
        const url = authService.pathUrl("GET", "/schools/email");
        const schoolsData = await authService.getAuth(url);
        setSchool(schoolsData);
      }
    } catch (error) {
      console.error("Error fetching schools:", error);
    }
  }

  const data = {
    ...emp,
    type,
    diseCode: school?.diseCode,
    companyName: school.schoolName,
    companyAddress: [school?.addressDTO?.addressLine1, school?.addressDTO?.city, school?.addressDTO?.pincode].join(" "),
    fromDate: dayjs(emp.joiningDate).format("DD MMM YYYY"),
    toDate: dayjs(emp.relievingDate !== null ? emp.relievingDate : dayjs()).format("DD MMM YYYY"),
    certificateNo: generateCertificateNumber(emp.code),
    issueDate: dayjs().format("DD MMM YYYY"),
    place: school?.addressDTO?.city,
    verifyUrl: `${window.location.origin}/verify/${emp.code}`
  };

  const addCertificate = async () => {
    const url = authService.pathUrl("POST", "/certificate");
    return await authService.postAuth(url, {
      id: emp?.empId,
      masterCode: school?.schoolCode,
      code: emp.code,
      designation: emp.designation,
      department: emp.department,
      certificateNo: data.certificateNo,
      active: data.active,
    });
  }

  const handlePrint = () => {
    const res = addCertificate();
    if (res.message === "Success") {
      setShow(false);
      setTimeout(() => {
        window.print();
        setShow(true);
      }, 100);
    }
  }

  return (
    <Box p={3}>
      {show && (
        <Box display="flex" gap={2} mb={2}>
          <Button onClick={() => navigate(-1)} sx={{ bgcolor: '#1b1914', color: '#fff' }}>Back</Button>

          <ToggleButtonGroup
            value={type}
            size="small"
            exclusive
            onChange={(_, v) => v && setType(v)}
          >
            <ToggleButton value="experience">Experience</ToggleButton>
            <ToggleButton value="service">Service</ToggleButton>
          </ToggleButtonGroup>

          <Button onClick={() => handlePrint()}>Print</Button>

          <Button
            variant="contained"
            onClick={() => {
              if (addCertificate().message === "Success")
                setTimeout(() => {
                  downloadCertificatePDF("certificate", "Certificate.pdf");
                  setShow(true);
                }, 100);
            }}
          >
            Download PDF
          </Button>
        </Box>

      )};

      <ExperienceCertificate data={data} />
    </Box>
  );
};

export default ExperienceCertificatePage;
